var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomTools = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    id: "cc376eluia"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#cc376eluia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.533 14.258 5.793 5.212a2.375 2.375 0 1 1-3.354 3.354l-5.226-5.808 2.787-2.758zM13.375 5.79c1.553 1.552 1.916 3.837 1.078 5.695l1.188 1.07-2.597 2.57-1.057-1.175c-1.858.838-4.142.475-5.694-1.077-1.572-1.572-1.925-3.895-1.045-5.766l2.827 2.826a1.67 1.67 0 1 0 2.36-2.36L7.61 4.745c1.871-.88 4.194-.527 5.766 1.045z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.608 6.773 22.733 9.55l-.547-.548a.5.5 0 0 1-.177.82 1.2 1.2 0 0 1-.887-.015l-7.5 7.5c.34.712.214 1.59-.375 2.18l-5.215 5.215a.685.685 0 0 1-.968 0l-1.74-1.74a.685.685 0 0 1 0-.969l5.215-5.214a1.916 1.916 0 0 1 2.18-.375l7.5-7.5a1.2 1.2 0 0 1-.016-.887.5.5 0 0 1 .82-.177l-.547-.547 2.778-1.875 1.354 1.354z",
    fill: "#9A5238"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomTools);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-tools.dd7b291e082d6fc30cbf2f77bbd96316.svg";